import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Throbber = ({ className, label, white, small }) => {
    const throbberBounceClasses = classNames({
        throbber__bounce: true,
        'throbber__bounce--white': white,
        'throbber__bounce--small': small,
    });

    return (
        <div className={classNames('throbber', className)}>
            {label && <p>{label}</p>}
            <div className={classNames('throbber__bounce--1', throbberBounceClasses)} />
            <div className={classNames('throbber__bounce--2', throbberBounceClasses)} />
            <div className={classNames('throbber__bounce--3', throbberBounceClasses)} />
        </div>
    );
};

Throbber.displayName = 'Throbber';

Throbber.propTypes = {
    className: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
    label: PropTypes.string,
    small: PropTypes.bool,
    white: PropTypes.bool,
};

Throbber.defaultProps = {
    label: '',
    small: false,
    white: false,
};

/**
 * Throbber functional component.
 */
export default Throbber;
